module.exports = __webpack_public_path__ + "img/pic8.29fff638.png";